import * as Mod1 from "./discourse/initializers/apple-auth-admin-plugin-configuration-nav";
const compatModules = {
  "discourse/initializers/apple-auth-admin-plugin-configuration-nav": Mod1,
};
export default compatModules;
